// ============================================
// utils/imagenes.js — helpers para optimizar URLs de imagen
// ============================================
// Las URLs de Syscom siguen el patrón:
//   .../SCSYS_207843_DS-2CE16D0T-LFS_-l.PNG
// Donde el sufijo final es:
//   -s = small  (~100x100)
//   -m = medium (~300x300)
//   -l = large  (~600x600)
// Para grids usamos -m (más liviano), para vista detalle -l.

/**
 * Devuelve la URL ajustada al tamaño indicado.
 * Si la URL no tiene el patrón -s/-m/-l antes de la extensión, se devuelve sin cambios.
 */
export function optimizarImagen(url, tamano = 'm') {
  if (!url || typeof url !== 'string') return url;
  if (!['s', 'm', 'l'].includes(tamano)) tamano = 'm';
  return url.replace(/-([lms])(\.[^.?#]+)([?#].*)?$/i, `-${tamano}$2$3`);
}

export default optimizarImagen;
